import { Button, Center, Icon, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiArrowLeft } from "react-icons/fi";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { urls } from "../../urls";
import { currentPathSuffix, validateReturnTo } from "../auth/returnTo";
import { ListLoadError } from "../ListLoadError";
import { isForbiddenError, isNoAccessError, isSignedOutError } from "./isNoAccessError";

export const EntityUnavailable = ({
  error,
  notFoundMessage,
  forbiddenMessage,
  loadFailedMessage,
  onRetry,
  isRetrying = false,
  back,
}: {
  error: unknown;
  notFoundMessage: string;
  forbiddenMessage: string;
  loadFailedMessage: string;
  onRetry: () => void;
  isRetrying?: boolean;
  back: { to: string; label: string };
}) => {
  if (isSignedOutError(error)) return <SignedOut />;
  return (
    <Center py={isNoAccessError(error) ? "20" : "10"}>
      <VStack spacing="4">
        {isNoAccessError(error) ? (
          <Text color="smMuted" textAlign="center">
            {isForbiddenError(error) ? forbiddenMessage : notFoundMessage}
          </Text>
        ) : (
          <ListLoadError message={loadFailedMessage} onRetry={onRetry} isRetrying={isRetrying} />
        )}
        <Button as={RouterLink} to={back.to} variant="outline" size="sm" leftIcon={<Icon as={FiArrowLeft} />}>
          {back.label}
        </Button>
      </VStack>
    </Center>
  );
};

const SignedOut = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const returnTo = validateReturnTo(currentPathSuffix(location));
  return (
    <Center py="20">
      <VStack spacing="4">
        <Text color="smMuted" textAlign="center">
          {t("You have been signed out. Sign in again to open this page.")}
        </Text>
        <Button as="a" href={returnTo ? urls.loginWithReturnUrl(returnTo) : urls.login} colorScheme="teal" size="sm">
          {t("Log in")}
        </Button>
      </VStack>
    </Center>
  );
};
